import { AppState } from "@Store/index";
import { useSelector, shallowEqual } from "react-redux";

const useCustomPaymentPage = () => {
  const { isError, isLoading } = useSelector(
    ({ bookFormData }: AppState) => ({
      isError: Boolean(bookFormData.paymentTokenData.err),
      isLoading: !bookFormData.paymentTokenData.data.token,
    }),
    shallowEqual,
  );

  return {
    isError,
    isLoading,
  };
};

export default useCustomPaymentPage;
